import { render, staticRenderFns } from "./ContentPages.vue?vue&type=template&id=7396c896"
import script from "./ContentPages.vue?vue&type=script&lang=js"
export * from "./ContentPages.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./ContentPages.vue?vue&type=style&index=0&id=7396c896&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "0fe0c413"
  
)

export default component.exports